import { IndexedInteractionStepResponse } from '@scale/shared/types/chat';
import { createContext, useContext } from 'react';
import {
  ResponseTemplateVariable,
  ResponseTemplatePopperMetadata,
} from 'react-scale/components/scalers/tasks/ThreadedInteraction/ResponseTemplateCreator/ResponseTemplateCreatorStep';

export const InlineResponseTemplatingContext = createContext({
  // This should be MultiTurnInteractionHistory, but importing MultiTurnInteractionHistory might be the cause of a circular dependency
  history: undefined as undefined | any,
  setResponseForIndex: async (_: IndexedInteractionStepResponse, __: number) => {},
  // This should be [InteractionStep | undefined, IndexedInteractionStepResponse | undefined][], but importing InteractionStep might be the cause of a circular dependency
  stepsWithResponses: [] as [any | undefined, IndexedInteractionStepResponse | undefined][],
  templatedResponses: [] as IndexedInteractionStepResponse[] | null,
  setTemplatedResponses: (_: IndexedInteractionStepResponse[]) => {},
  getVariables: () => [] as ResponseTemplateVariable[],
  setVariables: (_: ResponseTemplateVariable[]) => {},
  clear: () => {},
  // Used to handle automatic variable insertion for per model response templating
  updateResponseMiddleware: (
    _response: IndexedInteractionStepResponse,
    _metadata: ResponseTemplatePopperMetadata,
    _path: string,
    _value: any,
  ) => {},
});

export const useInlineResponseTemplatingContext = () => useContext(InlineResponseTemplatingContext);
